import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const SpinnerContainer = styled(Row)`
  min-height: 36px;
  align-items: center;
  justify-content: center;
`;
